export enum DeviceKind {
  WEB = 'WEB',
  MOBILE = 'ANDROID',
  IOS = 'IOS',
}
